module.exports = __webpack_public_path__ + "static/img/browserbg.059c325.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/browserbg.svg
// module id = pk4s
// module chunks = 3